import { useCallback } from 'react';

/**
 * Custom hook for URL parameter synchronization
 * Abstracts the common pattern of updating URL parameters based on state changes
 */
export const useUrlSetter = <T>(
  paramKey: string,
  setParam: (key: string, value: string) => void,
  removeParam: (key: string) => void,
  transform?: (value: T) => string,
  shouldSync?: (value: T) => boolean
) => {
  return useCallback((value: T | undefined) => {
    if (value && (!shouldSync || shouldSync(value))) {
      const urlValue = transform ? transform(value) : String(value);
      setParam(paramKey, urlValue);
    } else {
      removeParam(paramKey);
    }
  }, [paramKey, setParam, removeParam, transform, shouldSync]);
};